import type { ListTutorStageReason } from '@shared/model'

import { TutorKanbanStage } from '@brighterly/lib-core-types/tutor-kanban/enums'

const STAGE_REASON_KEY_OVERRIDES: Partial<Record<TutorKanbanStage, keyof ListTutorStageReason>> = {
  [TutorKanbanStage.ExitDecisionRequest]: 'needs_attention',
  [TutorKanbanStage.ExitInProgress]: 'needs_attention',
  [TutorKanbanStage.ExitFinished]: 'needs_attention',
  [TutorKanbanStage.ProbationFailed]: 'needs_attention',
}

export const getTutorStageReasonKey = (stage: string | null): keyof ListTutorStageReason | null => {
  if (!stage) return null
  return STAGE_REASON_KEY_OVERRIDES[stage as TutorKanbanStage]
    ?? (stage.toLowerCase() as keyof ListTutorStageReason)
}
